require('./bootstrap');

const DataMonitor = {
    dataPeriod: null,
    totalProduction: 0,
    totalSelfConsumption: 0,

    loadSites: async function () {
        let fetchResponse = await fetch(route('get-sites'));
        let data = await fetchResponse.json();

        if (data != null && data.error_message === undefined) {
            let siteFilter = document.querySelector('form.filters select.site-filter');
            if (data.sites.count > 1 && siteFilter) {
                siteFilter.classList.remove('d-none');
            }

            for (let i in data.sites.site) {
                let option = document.createElement('option');
                option.setAttribute('value', data.sites.site[0].id);
                option.appendChild(document.createTextNode('Site #' + data.sites.site[0].id));
                if (data.sites.count === 1) {
                    option.setAttribute('selected', 'selected');
                }
                siteFilter.appendChild(option);
            }

            await DataMonitor.loadDataPeriod();

            DataMonitor.loadPeriodTotalEnergy();
            DataMonitor.loadMonthEnergy();
            DataMonitor.loadTodayEnergy();
            DataMonitor.loadChartData();
            DataMonitor.hideLoader();
        } else if (data.error_message !== undefined) {
            setTimeout(() => {window.location.reload();}, 5000);
        }
    },

    loadDataPeriod: async function () {
        let options = document.querySelector('.site-filter').options;
        let routeUrl = route(
            'data-period',
            [options[options.selectedIndex].value]
        );

        let fetchResponse = await fetch(routeUrl);
        let data = await fetchResponse.json();

        if (data != null) {
            DataMonitor.dataPeriod = data.dataPeriod;
            let startYear = moment(data.dataPeriod.startDate).format('YYYY');
            let endYear = moment(data.dataPeriod.endDate).format('YYYY');
            const yearFilter = document.querySelector('.year-filter');
            const startDatetime = document.querySelector('#start-datetime');

            for (let i = parseInt(startYear) - 1; i < parseInt(endYear); i++) {
                let option = document.createElement('option');
                option.setAttribute('value', i+1);
                option.appendChild(document.createTextNode(i+1));
                yearFilter.appendChild(option);
            }
        }
    },

    loadChartData: function (chartId) {
        chartId = chartId === undefined ? 'daily-chart' : chartId;

        switch (chartId) {
            case 'daily-chart':
                DataMonitorChart.createChart('#' + chartId, 'line');
                break;
            case 'weekly-chart':
                DataMonitorChart.createChart('#' + chartId, 'line');
                break;
            case 'monthly-chart':
                DataMonitorChart.createChart('#' + chartId, 'bar');
                break;
            case 'yearly-chart':
                DataMonitorChart.createChart('#' + chartId, 'bar');
                break;
            default:
                DataMonitorChart.createChart('#' + chartId, 'line');
        }
        

        DataMonitor.loadEnvironmentalBenefits();
    },

    loadEnvironmentalBenefits: function () {
        let options = document.querySelector('.site-filter').options;
        let routeUrl = route(
            'environmental-benefits',
            [options[options.selectedIndex].value]
        );

        fetch(routeUrl).then((response) => response.json()).then((data) => {
            if (data != null && data.envBenefits !== undefined) {
                document.querySelectorAll('.co2-emission').forEach(function (e) {
                    e.innerHTML = parseFloat(data.envBenefits.gasEmissionSaved.co2).toFixed(2);
                });
                document.querySelectorAll('.trees-planted').forEach(function (e) {
                    e.innerHTML = parseFloat(data.envBenefits.treesPlanted).toFixed(2);
                });
            }
        });
    },

    loadPowerDetails: async function (selector) {
        let timeUnit = selector === '#daily-chart' ? 'DAY' : 'WEEK';
        let options = document.querySelector('.site-filter').options;
        let startTime = moment(document.querySelector('#start-datetime').value);
        let endTime = moment(document.querySelector('#start-datetime').value);

        if (selector === '#weekly-chart') {
            startTime = endTime.add(-8, 'days');
            endTime = moment(document.querySelector('#start-datetime').value);
        }

        let routeUrl = route(
            'power-details',
            [
                options[options.selectedIndex].value,
                timeUnit,
                startTime.format('YYYY-MM-DD 00:00:00'),
                endTime.format('YYYY-MM-DD 23:59:59'),
            ]
        );

        let fetchResponse = await fetch(routeUrl);
        let result = await fetchResponse.json();

        return result;
    },

    loadEnergyDetails: async function (selector) {
        let timeUnit = selector === '#monthly-chart' ? 'MONTH' : 'YEAR'
        let siteOptions = document.querySelector('.site-filter').options;
        let monthOptions = document.querySelector('.month-filter').options;
        let startTime = moment(
            moment().format('YYYY-' + monthOptions[monthOptions.selectedIndex].value + '-01')
        );
        let endTime = moment(
            moment().format('YYYY-' + monthOptions[monthOptions.selectedIndex].value + '-01')
        ).add(1, 'month').add(-1, 'day');

        let routeUrl = route(
            'energy-details',
            [
                siteOptions[siteOptions.selectedIndex].value,
                timeUnit,
                startTime.format('YYYY-MM-DD'),
                endTime.format('YYYY-MM-DD'),
            ]
        );

        let fetchResponse = await fetch(routeUrl);
        let result = await fetchResponse.json();

        return result;
    },

    hideLoader: function () {
        document.querySelector('.loader').classList.add('d-none');
    },

    showLoader: function () {
        document.querySelector('.loader').classList.remove('d-none');
    },

    loadPeriodTotalEnergy: async function () {
        let options = document.querySelector('.site-filter').options;
        let routeUrl = route(
            'time-frame-energy',
            [options[options.selectedIndex].value, DataMonitor.dataPeriod.startDate, DataMonitor.dataPeriod.endDate]
        );

        let fetchResponse = await fetch(routeUrl);
        let data = await fetchResponse.json();

        if (data != null) {
            let eneryConversion = this.converter(data.timeFrameEnergy.energy, data.timeFrameEnergy.unit);

            document.querySelectorAll('.period-energy').forEach(function(e) {
                e.innerHTML = eneryConversion.energy;
            });
            document.querySelectorAll('.period-energy-unit').forEach(function(e) {
                e.innerHTML = eneryConversion.unit;
            });
        }
    },

    loadMonthEnergy: async function () {
        let options = document.querySelector('.site-filter').options;
        let routeUrl = route(
            'time-frame-energy',
            [options[options.selectedIndex].value]
        );

        let fetchResponse = await fetch(routeUrl);
        let data = await fetchResponse.json();

        if (data != null) {
            let eneryConversion = this.converter(data.timeFrameEnergy.energy, data.timeFrameEnergy.unit);

            document.querySelectorAll('.month-energy').forEach(function(e) {
                e.innerHTML = eneryConversion.energy;
            });
            document.querySelectorAll('.month-energy-unit').forEach(function(e) {
                e.innerHTML = eneryConversion.unit;
            });
        }
    },

    loadTodayEnergy: async function () {
        let options = document.querySelector('.site-filter').options;
        let routeUrl = route(
            'time-frame-energy',
            [options[options.selectedIndex].value, 0, DataMonitor.dataPeriod.endDate]
        );

        let fetchResponse = await fetch(routeUrl);
        let data = await fetchResponse.json();

        if (data != null) {
            let eneryConversion = this.converter(data.timeFrameEnergy.energy, data.timeFrameEnergy.unit);

            document.querySelectorAll('.today-energy').forEach(function(e) {
                e.innerHTML = eneryConversion.energy;
            });
            document.querySelectorAll('.today-energy-unit').forEach(function(e) {
                e.innerHTML = eneryConversion.unit;
            });
        }
    },

    converter: function (energy, unit) {
        let conversion = {
            energy: energy,
            unit: unit,
        };

        if (unit.toLowerCase() === 'w') {
            if (energy >= 1000 && energy < 1000000) {
                conversion.energy = energy / 1e3;
                conversion.unit = 'kW';
            } else if (energy >= 1000000) {
                conversion.energy = energy / 1e6;
                conversion.unit = 'MWh';
            }
        }

        if (unit.toLowerCase() === 'wh') {
            if (energy >= 1000 && energy < 1000000) {
                conversion.energy = energy / 1e3;
                conversion.unit = 'kWh';
            } else if (energy >= 1000000) {
                conversion.energy = energy / 1e6;
                conversion.unit = 'MWh';
            }
        }

        conversion.energy = parseFloat(conversion.energy).toFixed(2).toString().replace('.', ',');

        return conversion;
    },
};

let DataMonitorChart = {
    currentChart: null,

    addFilterListeners: function () {
        document.querySelectorAll('input[type="date"]').forEach(function(e) {
            e.addEventListener('click', function(event) {
                event.target.showPicker();
            });
            e.addEventListener('focus', function(event) {
                event.target.showPicker();
            });
        });

        document.querySelectorAll('.filters .filter-item').forEach(function(e) {
            e.addEventListener('change', function(event) {
                DataMonitor.loadChartData(document.querySelector(
                    '#chart-carousel .carousel-item.active canvas'
                )?.id);
            });
        });
    },

    addCarouselListener: function () {
        const callback = function (event) {
            let currentChartCanvasId = document.querySelector(
                '#chart-carousel .carousel-item:nth-child(' + (event.to + 1) + ') canvas'
            )?.id;

            document.querySelectorAll('.filters .filter-item').forEach(function (e) {
                if (!e.classList.contains('site-filter')) {
                    e.classList.add('d-none');
                    if (
                        (currentChartCanvasId == 'daily-chart'
                        || currentChartCanvasId == 'weekly-chart')
                        && e.classList.contains('date-filter')
                    ) {
                        e.classList.remove('d-none');
                    }

                    if (
                        currentChartCanvasId == 'monthly-chart'
                        && (e.classList.contains('month-filter') || e.classList.contains('year-filter'))
                    ) {
                        e.classList.remove('d-none');
                    }

                    if (
                        currentChartCanvasId == 'yearly-chart'
                        && e.classList.contains('year-filter')
                    ) {
                        e.classList.remove('d-none');
                    }
                }
            });

            DataMonitor.loadChartData(currentChartCanvasId);
        };
        
        document.getElementById('chart-carousel').addEventListener('slide.bs.carousel', callback)
    },

    generateLabels: function (selector) {
        let labels = [];
        let startTime = moment(document.querySelector('#start-datetime').value);
        let monthFilter = document.querySelector('.month-filter').options;
        let yearFilter = document.querySelector('.year-filter').options;

        if (selector === '#daily-chart') {
            labels = [];
            for (let i = 1; i<=96; i++) {
                labels[i] = startTime.add(15, 'minutes').format("HH:mm");
            }
        }

        if (selector === '#weekly-chart') {
            let endTime = moment(document.querySelector('#start-datetime').value);
            startTime = endTime.add(-7, 'days');
            labels = [];
            for (let i = 0; i<767; i++) {
                labels[i] = startTime.add(15, 'minutes').format("ll");
            }
        }

        if (selector === '#monthly-chart') {
            labels = [];
            let numDaysCurrentMonth = moment().daysInMonth();
            for (let i = 0; i < numDaysCurrentMonth; i++) {
                labels[i] = moment(
                    yearFilter[yearFilter.selectedIndex].value
                    + monthFilter[monthFilter.selectedIndex].value
                    + "01 00:00:00",
                    "YYYYMMDD"
                ).add(i, 'days').format("ll");
            }
        }

        if (selector === '#yearly-chart') {
            labels = [];
            for (let i = 0; i<12; i++) {
                labels[i] = moment(
                    yearFilter[yearFilter.selectedIndex].value + "0101 00:00:00", "YYYYMMDD"
                ).add(i, 'months').format("MMMM");
            }
        }
        
        return labels;
    },

    getData: function (values, type, selector) {
        let data = [];
        let unitDivisor = 1e3;

        if (selector === '#monthly-chart' || selector === '#yearly-chart') {
            unitDivisor = 1e6;
        }

        for (let i = 0; i < values.length; i++) {
            data[i] = values[i].value !== undefined ? parseFloat(values[i].value / unitDivisor).toFixed(2) : 0;
            if (type === 'Production' && values[i].value !== undefined) {
                DataMonitor.totalProduction += values[i].value;
            }

            if (type === 'SelfConsumption' && values[i].value !== undefined) {
                DataMonitor.totalSelfConsumption += values[i].value;
            }
        }

        return data;
    },

    generateDataset: async function (selector) {
        let metersTrans = JSON.parse(document.querySelector('#chart-carousel').dataset.metersTrans);
        let dataset = [
            {
                label: metersTrans['Production'],
                data: [],
                fill: true,
                backgroundColor: '#198754',
            },
            {
                label: metersTrans['Consumption'],
                data: [],
                fill: true,
                backgroundColor: '#dc3545',
            },
            {
                label: metersTrans['SelfConsumption'],
                data: [],
                fill: true,
                backgroundColor: '#376fc1',
            }
        ];

        if (selector === '#daily-chart' || selector === '#weekly-chart') {
            let jsonData = await DataMonitor.loadPowerDetails(selector);

            if (jsonData.powerDetails !== undefined) {
                for (let i in jsonData.powerDetails.meters) {
                    if (jsonData.powerDetails.meters[i].type === 'Production') {
                        dataset[0].data = DataMonitorChart.getData(
                            jsonData.powerDetails.meters[i].values,
                            jsonData.powerDetails.meters[i].type
                        );
                    }

                    if (jsonData.powerDetails.meters[i].type === 'Consumption') {
                        dataset[1].data = DataMonitorChart.getData(jsonData.powerDetails.meters[i].values);
                    }

                    if (jsonData.powerDetails.meters[i].type === 'SelfConsumption') {
                        dataset[2].data = DataMonitorChart.getData(
                            jsonData.powerDetails.meters[i].values,
                            jsonData.powerDetails.meters[i].type
                        );
                    }
                }
            }
        };

        if (selector === '#monthly-chart' || selector === '#yearly-chart') {
            let jsonData = await DataMonitor.loadEnergyDetails(selector);

            if (jsonData.energyDetails !== undefined) {
                for (let i in jsonData.energyDetails.meters) {
                    if (jsonData.energyDetails.meters[i].type === 'Production') {
                        dataset[0].data = DataMonitorChart.getData(
                            jsonData.energyDetails.meters[i].values,
                            null,
                            selector
                        );
                    }

                    if (jsonData.energyDetails.meters[i].type === 'Consumption') {
                        dataset[1].data = DataMonitorChart.getData(
                            jsonData.energyDetails.meters[i].values,
                            null,
                            selector
                        );
                    }

                    if (jsonData.energyDetails.meters[i].type === 'SelfConsumption') {
                        dataset[2].data = DataMonitorChart.getData(
                            jsonData.energyDetails.meters[i].values,
                            null,
                            selector
                        );
                    }
                }
            }
        };

        return dataset;
    },

    createChart: async function (selector, type) {
        if (DataMonitorChart.currentChart != null) {
            DataMonitorChart.currentChart.destroy();
        }

        let datasets = await DataMonitorChart.generateDataset(selector);

        if (DataMonitor.totalProduction > 0 && DataMonitor.totalSelfConsumption > 0) {
            document.querySelectorAll('.production-total').forEach(function(e) {
                e.innerHTML = parseFloat(DataMonitor.totalProduction / 1e6).toFixed(2);
            });

            document.querySelectorAll('.self-consumption-total').forEach(function(e) {
                e.innerHTML = parseFloat(
                    (DataMonitor.totalSelfConsumption / DataMonitor.totalProduction)*100
                ).toFixed(2) + '%';
            });
        }

        let yUnit = 'k';

        if (selector === '#monthly-chart' || selector === '#yearly-chart') {
            yUnit = 'M';
        }

        try {
            DataMonitorChart.currentChart = new Chart(
                document.querySelector(selector),
                {
                    type: type,
                    data: {
                        labels:  DataMonitorChart.generateLabels(selector),
                        datasets: datasets,
                    },
                    options: {
                        responsive: true,
                        interaction: {
                            intersect: false,
                            mode: 'index',
                        },
                        elements:{
                            point:{
                                borderWidth: 0,
                                radius: 0,
                            }
                        },
                        maintainAspectRatio: false,
                        scales: {
                            y : {
                                ticks: {
                                    callback: function(value, index) {
                                        return value + ' ' + yUnit
                                    },
                                }
                            },
                        }
                    }
                }
            );
        } catch (e) {
            // e
        }
    }
}


DataMonitor.loadSites();
DataMonitorChart.addFilterListeners();
DataMonitorChart.addCarouselListener();

const carousel = new bootstrap.Carousel('#chart-carousel', {interval: 10000, touch: true});